export var STOCK_FEEDBACK = {
    Status: null,
    Content: null,
};
